<template>
  <div class="container">
    <el-row>
      <ul>
        <li
          @dblclick="dbclick(item)"
          @click="onclick(item)"
          v-for="item in taskGroupCurrent"
          :key="item.ID"
          @contextmenu.prevent="liContextmenu(item)"
          v-contextmenu:contextmenu
        >
          <i :class="[{iconfont:true},item.HasSub ? 'icon-weibiaoti5' : 'icon-renwu5']"></i>
          <div class="title">{{item.TASKNAME}}</div>
        </li>
      </ul>
    </el-row>
    <v-contextmenu ref="contextmenu">
      <v-contextmenu-item @click="open()">打开</v-contextmenu-item>
      <v-contextmenu-item @click="handleFolderMenuClick()">详情</v-contextmenu-item>
    </v-contextmenu>
  </div>
</template>
<script>
import treeToArray from "@/util/EvalDataToTree";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
export default {
  name: "taskGroupCurrent",
  components: {},
  props: {},
  data() {
    return {
      resizeTimer: null, // 自适应高度的定时器
      expandAll: false, // 表格是否展开
      selectedRow: null, // 当前选择的行的数据
      contextmenuRow: {},
      listHeight:
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight - 1000, //（这里的240是减去表格上面导航和搜索条件的高度）
      columns: [
        // 列
        {
          text: "任务单号",
          value: "INSTANCE"
        },
        {
          text: "任务类型",
          value: "TASKTYPENAME",
          width: 200
        },
        {
          text: "执行状态",
          value: "TASKSTATENAME"
        },
        {
          text: "任务名称",
          value: "TASKNAME"
        },
        {
          text: "创建人",
          value: "CREATEUSERNAME"
        },
        {
          text: "创建时间",
          value: "CREATETIME"
        },
        {
          text: "执行人",
          value: "EXCUTEUSERNAME"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      taskGroupCurrent: state => state.task.taskGroupCurrent,
      taskGroupList: state => state.task.taskGroupList,
      taskGroupNative: state => state.task.taskGroupNative,
      taskGropuParent: state => state.task.taskGropuParent
    }),
    formatData() {
      let tmp = this.taskGroupCurrent;
      const func = treeToArray;
      const args = [tmp, this.expandAll];
      return func.apply(null, args);
    }
  },
  mounted() {},
  methods: {
    timeFormat(time) {
      // 时间格式化
      return time.substring(0, 19).replace("T", " ");
    },
    onclick(row) {
      this.$store.dispatch("changeCurTask", row);
    },
    showRow(row) {
      // 是否展示子任务
      const show = row.row.parent
        ? row.row.parent._expanded && row.row.parent._show
        : true;
      row.row._show = show;
      return show
        ? "animation:treeTableShow 1s;-webkit-animation:treeTableShow 1s;"
        : "display:none;";
    },
    toggleExpanded(trIndex) {
      // 切换下级是否展开
      const record = this.formatData[trIndex];
      record._expanded = !record._expanded;
    },
    iconShow(index, record) {
      // 图标显示
      return index === 0 && record.children && record.children.length > 0;
    },
    handleCurrentChange(row) {
      // 选中行数据
      this.$emit("changeCurTask", row);
    },
    dbclick(row) {
      //双击行事件
      if (row.HasSub) {
        this.$store.commit("setTaskGroupCurrent", row.ID);
      } else {
        this.$store.dispatch("changeCurTask", row);
        this.openBlank(row.ID);
      }
    },
    liContextmenu(row) {
      this.contextmenuRow = row;
    },
    open() {
      this.dbclick(this.contextmenuRow);
    },
    handleFolderMenuClick() {
      this.$store.dispatch("changeCurTask", this.contextmenuRow);
      this.openBlank(this.contextmenuRow.ID);
    },
    openBlank(taskid) {
      let routeUrl = this.$router.resolve({
        path: "/task-detailspage",
        query: { taskid: taskid }
      });
      window.open(routeUrl.href, "_blank");
    }
  }
};
</script>
<style scoped lang="less">
@keyframes treeTableShow {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes treeTableShow {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.sonTaskColor {
  color: #ffb84b;
}
.NameHighLight {
  cursor: pointer;
  color: #46a1ff;
}
.ms-tree-space {
  position: relative;
  top: 1px;
  display: inline-block;
  font-style: normal;
  font-weight: 400;
  line-height: 1;
  width: 18px;
  height: 14px;
}
.ms-tree-space::before {
  content: "";
}
.processContainer {
  width: 100%;
  height: 100%;
  margin-bottom: 40px;
}
table td {
  line-height: 26px;
}
.tree-ctrl {
  position: relative;
  cursor: pointer;
  color: #2196f3;
  margin-left: -18px;
  margin-right: 5px;
}
</style>
<style scoped lang="scss">
.container {
  // display: table;
  margin-right: 20px;
  // height: 100%;
  // position: fixed;
  margin: -8px;
  background: white;
  margin-top: 3px;
  margin-left: 0px;
  .line {
    height: 30px;
    margin-top: 30px;
    background-color: #f1f1f1;
  }
  ul {
    /*ul向div父元素右方浮动*/
    list-style: none;
    /*将默认的列表符号去掉*/
    margin: 0;
    /* 将默认的内边距去掉 */
    padding: 2px;
    /* 将默认的外边距去掉 */
  }
  li {
    // list-style: none;
    margin: 10px 20px 0px 10px;
    padding: 10px 10px 20px 10px;
    float: left;
    width: 120px;
    height: 120px;
    text-align: center;
    font-size: 18px;
    color: #5b6379;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    // white-space: nowrap;
  }

  .iconfont {
    font-size: 40px;
  }
  li:hover {
    background-color: #0099ff;
    color: white;
    border-radius: 5px;
    // border: 1px solid #ebeef5;
  }

  .title {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    // text-align: left;
    -webkit-box-orient: vertical;
    font-size: 17px;
    color: #282828;
    font-weight: bolder;
  }
}
</style>
